module.exports = __webpack_public_path__ + "img/pink.f617628b.png";